import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';

export const projectLinkDataArraySelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      diagramSnapshotSelector(projectId),
      (diagram) => diagram?.model?.linkDataArray || []
    )
);

export const prevProjectLinkDataArraySelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      diagramSnapshotSelector(projectId),
      (diagram) => diagram?.model?.modelData.draftData?.prevLinkDataArray || []
    )
);
